export default __webpack_public_path__ + "static/media/rehack-team.94535334.jpg";